import React from "react";
import Meaning from "./Meaning";
import "./Results.css";

export default function Results(props) {
    if (props.results) {
        return (
            <div className="Results">
                <section>
                    <h2 style={{textTransform:"capitalize"}}>{props.results.word}</h2>
                    <div className="Phonetic">
                    {props.results.phonetic}
                    </div>
                </section>
                    {props.results.meanings
                    .slice(0, 1)
                    .map(function (meaning, index) {
                        return (
                        <section key={index}>    
                        <Meaning meaning={meaning} />
                        </section>
                );
            })}
            </div>
    );
    } else {
        return null;
    }
}
